<div class="flex flex-middle">
    <a type="button"
       [routerLink]="'/account/information-centre'"
       class="inline-flex">
        <span class="page-header__icon"
              [ngClass]="(numberOfUnreadMessages < 100 && numberOfUnreadMessages) ? '_bullet-normal' : '_bullet-small'"
              [attr.aria-label]="'Unread messages quantity %' | translate : numberOfUnreadMessages"
              [attr.qty-bullet]="qtyBulletContent">
            <i class="icon-notification"
               aria-hidden="true"></i>
        </span>
    </a>
</div>
